import { render } from "./CheckboxComponent.vue?vue&type=template&id=69fa5a23&scoped=true"
import script from "./CheckboxComponent.vue?vue&type=script&lang=js"
export * from "./CheckboxComponent.vue?vue&type=script&lang=js"

import "./CheckboxComponent.vue?vue&type=style&index=0&id=69fa5a23&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69fa5a23"]])

export default __exports__